import React from "react";
import WithLabel from "./WithLabel";
import {workAttrList} from "../../../types/workForm";
import Pjdb1CheckBox from "../../../../../components/inputs/Pjdb1CheckBox";

export interface DeformableProps {
  // eslint-disable-next-line react/require-default-props
  value?: boolean;
  // eslint-disable-next-line react/require-default-props
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  // eslint-disable-next-line react/require-default-props
  required?: boolean;
  // eslint-disable-next-line react/require-default-props
  disabled?: boolean;
  // eslint-disable-next-line react/require-default-props
  isClear?: boolean;
}

export default function Deformable(props: DeformableProps) {
  return (
    <WithLabel label={workAttrList.deformable.label}>
      <Pjdb1CheckBox
        label={workAttrList.deformable.meta.yes}
        name={workAttrList.deformable.key}
        value={props.value ?? false}
        onChange={props.onChange}
        disabled={props.disabled}
        toolTip="不定形物であればチェック"
      />
    </WithLabel>
  )
}
